export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-fr.c2d3e526.svg";